import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';

export default class ClassificationRulesApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getAll(): Promise<any> {
    return super.get(api.get_doc_classification_rules);
  }

  public async create(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.post(api.create_doc_classification_rule, formData);
  }

  public async delete(id: string): Promise<any> {
    return super.delete(api.delete_doc_classification_rule + '/' + id, {});
  }

  public async update(data: any): Promise<any> {
    const id = data.id;
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }

    return super.put(api.update_doc_classification_rule + '/' + id, formData);
  }
}
